import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { usePagination } from 'react-instantsearch';
import Search from '@/components/customercenter-ui/svgs/search';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../../constants/constant';
import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';
import { PageTexts } from '../i18n';
interface Props {
  setLoading?: any;
  refine?: any;
}

const SearchBarComponent: React.FC<Props> = ({ setLoading }) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  const { refine } = usePagination();
  const router = useRouter();
  const params = useSearchParams();
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchInput, setSearchInput] = useState('');

  const sanitizeInput = (input: string): string => {
    return input.replace(/[^a-zA-Z0-9\s'"\/.:&+\?®™-]/g, ' ');
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const inputQuery = searchInput;
    const originalInput = inputQuery?.trim();
    const transformedInput = sanitizeInput(originalInput);
    const sanitizedInput = transformedInput?.replace(/\s+/g, ' ').trim();

    if (searchInput === '999999') {
      router.push('/product/p/999999/');
      return;
    }

    if (params.get('q') === sanitizedInput) return;
    router.push(`/search?q=${encodeURIComponent(sanitizedInput)}&backUrl=${false}`);
    refine(0);
    setLoading(true);
  };

  const handleSearchBoxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const sanitizedInput = e.target.value.replace(/[^a-zA-Z0-9\s'"\/.:&+\?®™-]/g, ' ');
    setSearchInput(sanitizedInput);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="relative m-4 w-[400px]">
      <form onSubmit={handleSubmit}>
        <Input
          ref={inputRef}
          placeholder={Texts.searchPlaceholder}
          className="gbunmask relative w-[400px] rounded-md border-[1px] p-2 pr-12 text-sm"
          value={searchInput}
          onChange={(e) => handleSearchBoxChange(e)}
        />
        <Button
          className="absolute right-0 top-0 rounded-none rounded-r-md pl-3 text-3xl"
          type="submit"
          aria-label="Search"
        >
          <Search />
        </Button>
      </form>
    </div>
  );
};

export default SearchBarComponent;
